<button type="button" class="btn btn-primary" (click)="this.openModal(modalContent);">
    <svg><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
    <span cvLocalizedText [langSection]="LocalizationSection" [langKey]="'New_Hierarchy'">New Hierarchy</span>
</button>


<ng-template #modalContent let-modal>
    <div *ngIf="IsLoading" style="height: 605px;">
        <cv-loader [size]="'large'" [overlay]="false"></cv-loader>
    </div>
    <div *ngIf="!IsLoading">
        <div class="modal-header">
            <div *ngIf="!IsEditing" class="modal-title d-flex justify-content-between header" 
                cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Header_Add'">Add A New Hierarchy Group</div>
            <div *ngIf="IsEditing" class="modal-title d-flex justify-content-between header" 
                cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Header_Edit'">Modify A Hierarchy Group</div>
            <button type="button" class="modal-close icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="closeModal();">
                <svg class="icon-16">
                    <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
        </div>
        <div class="modal-body">
            <div>
                <div class="d-flex">
                    <span cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Name'">Name</span>
                    <span class="flex-fill"></span>
                    <span>{{model.Name.length}} / 50</span>
                </div>               
                <input autocomplete="false" class="form-control" type="text" [(ngModel)]="model.Name" 
                    [placeholder]="getLocalizedText('Hierarchy_Name_Placeholder', 'Name')"
                    [maxLength]="50" />
            </div>
            <hr />
            <div>
                <div class="header" cvLocalizedText [langSection]="LocalizationSection" [langKey]="'User_Role_Header'">Who should be able to see this group?</div>
                <div class="subtext" cvLocalizedText [langSection]="LocalizationSection" [langKey]="'User_Role_Desc'">This determines who sees the group on group filters in the system.</div>
                <div class="p-2 access-shadowed-border">
                    <div class="header" style="color: red;">[( This section is not saved yet, but will be for full release so it is required to pick one for now )]</div>
                    <div class="header" cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Roles_Header'">Roles that have access:</div>
                    <mat-form-field #roleDropdownSelector class="cv-material-control" appearance="fill">
                        <mat-select
                            [attr.id]="'custom-hierarchy-available-roles'"
                            class="my-auto w-100 lato-regular"
                            panelClass="cv-material-control"
                            [placeholder]="getLocalizedText('Roles_Placeholder', 'Select Role(s)')"
                            [(ngModel)]="model.SelectedRoles"
                            [multiple]="true"                            
                            [disableRipple]="true"
                            [compareWith]="compareRoles"
                            [attr.select-type]="'roles'"
                        >
                            <mat-select-trigger>
                                {{ selectedRolesText }}
                            </mat-select-trigger>
                            <div class="search-box live-search">
                                <input type="search" class="form-control form-control-lg" 
                                    [(ngModel)]="roleSearchTerm" 
                                    onkeydown="event.stopPropagation()" 
                                    cvLocalizedPlaceholder [langSection]="LocalizationSection" [langKey]="'Search'" />
                                <span class="clear-input" [hidden]="roleSearchTerm == ''" (click)="roleSearchTerm = ''"></span>
                            </div>                            
                            <div class="d-flex">
                                <button type="button" class="btn btn-secondary flex-50" (click)="onRolesAllClicked()"
                                    cvLocalizedText [langSection]="LocalizationSection" [langKey]="'All'">All</button>
                                <button type="button" class="btn btn-secondary flex-50" (click)="onRolesNoneClicked()"
                                    cvLocalizedText [langSection]="LocalizationSection" [langKey]="'None'">None</button>
                            </div>
                            <cdk-virtual-scroll-viewport [itemSize]="36" [minBufferPx]="200" [maxBufferPx]="400" style="height: 188px;">
                                <mat-option *cdkVirtualFor="let role of availableRoles | filterText: roleSearchTerm"
                                    [value]="role">
                                    {{ role.ProfileName }}
                                </mat-option>
                            </cdk-virtual-scroll-viewport>
                        </mat-select>
                    </mat-form-field>
                    <div class="font-size-16 d-flex flex-row flex-wrap overflow-auto" style="min-height: 34px; max-height: 12vh;">
                        <span *ngFor="let selectedRole of model.SelectedRoles" class="settings-hover-colors rounded-pill px-2 mx-1 my-1">{{ selectedRole.ProfileName }}
                            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail ml-2" (click)="removeSelectedRole(selectedRole)">
                                <svg class="icon-12">
                                    <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                                </svg>
                            </button>
                        </span>
                    </div>

                    <div class="header" cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Users_Header'">Users that have access:</div>
                    <mat-form-field class="cv-material-control" appearance="fill">
                        <mat-select
                            [attr.id]="'custom-hierarchy-available-users'"
                            class="my-auto w-100 lato-regular"
                            panelClass="cv-material-control"
                            [(ngModel)]="model.SelectedLogins"
                            [multiple]="true"
                            [placeholder]="'Select Login(s)'"
                            [disableRipple]="true"
                            [compareWith]="compareLogins"
                            [attr.select-type]="'logins'"
                        >
                            <mat-select-trigger>
                                {{ selectedLoginsText }}
                            </mat-select-trigger>
                            <div class="search-box live-search">
                                <input type="search" class="form-control form-control-lg" placeholder="Search" [(ngModel)]="userSearchTerm" onkeydown="event.stopPropagation()" />
                                <span class="clear-input" [hidden]="userSearchTerm == ''" (click)="userSearchTerm = ''"></span>
                            </div>
                            <div class="d-flex">
                                <button type="button" class="btn btn-secondary flex-50" (click)="onLoginsAllClicked()">All</button>
                                <button type="button" class="btn btn-secondary flex-50" (click)="onLoginsNoneClicked()">None</button>
                            </div>
                            <cdk-virtual-scroll-viewport [itemSize]="36" [minBufferPx]="200" [maxBufferPx]="400" style="height: 188px;">
                                <mat-option *ngFor="let login of availableLogins | filterText: userSearchTerm" 
                                    [value]="login">
                                    {{ login.LoginName }}
                                </mat-option>
                            </cdk-virtual-scroll-viewport>
                        </mat-select>
                    </mat-form-field>
                    <div class="font-size-16 d-flex flex-row flex-wrap overflow-auto" style="min-height: 34px; max-height: 12vh;">
                        <span *ngFor="let selectedLogin of model.SelectedLogins" class="settings-hover-colors rounded-pill px-2 mx-1 my-1">{{ selectedLogin.LoginName }}
                            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail ml-2" (click)="removeSelectedLogin(selectedLogin)">
                                <svg class="icon-12">
                                    <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                                </svg>
                            </button>
                        </span>
                    </div>
                </div>
            </div>
            <hr />
            <div>
                <div class="header" cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Levels_Header'">What should the group look like?</div>
                <div class="subtext" cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Levels_Desc'">The levels set here will show the inheritance starting from level 1 (base level) onwards.</div>
                <button type="button" [disabled]="IsEditing" class="btn btn-text btn-icon fill-cerulean" (click)="addAggregationLevel();" [title]="IsEditing ? 'Aggregation levels cannot be added after initial creation.' : 'Add a new aggregation level.'">
                    <svg><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                    <span cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Add_Level_Button'">Add Aggregation Level</span>
                </button>

                <div style="height: 120px; overflow: auto;">
                    <div *ngFor="let level of model.AggregationLevels.slice().reverse(); let $idx = index;" class="d-flex mb-2">
                        <span class="pt-1" cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Name'">Name</span>
                        <input autocomplete="false" class="form-control ml-2" type="text" placeholder="Level Name" [(ngModel)]="level.Name"/>
                        <button *ngIf="model.AggregationLevels.length > 1 && !IsEditing" type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail ml-2" (click)="removeAggregationLevel($idx)">
                            <svg class="icon-16">
                                <use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-text mr-2" (click)="closeModal();" cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Cancel_Button'">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="saveModal();" cvLocalizedText [langSection]="LocalizationSection" [langKey]="'Save_Button'">Save</button>
        </div>
    </div>
</ng-template>